var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8273 26.609V28H13.1727V26.609H22.8273ZM23.3045 26.2176V9.78244C23.3045 9.56657 23.0904 9.39096 22.8273 9.39096H13.1727C12.9096 9.39096 12.6955 9.56656 12.6955 9.78244V26.2176C12.6955 26.4334 12.9096 26.609 13.1727 26.609V28L12.9502 27.9907C11.8548 27.8993 11 27.1403 11 26.2176V9.78244C11 8.85972 11.8548 8.10066 12.9502 8.00934L13.1727 8H22.8273C24.0271 8 25 8.79817 25 9.78244V26.2176L24.9886 26.4001C24.8773 27.2988 23.952 28 22.8273 28V26.609C23.0904 26.609 23.3045 26.4334 23.3045 26.2176Z",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8672 15.2812V16.8809H11.1143V15.2812H23.8672Z",
    fill: "#3F3F3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11.7354C14.2501 11.2936 14.608 10.9355 15.0498 10.9355C15.4916 10.9355 15.8495 11.2936 15.8496 11.7354L15.8496 14.0127C15.8496 14.4545 15.4916 14.8125 15.0498 14.8125C14.608 14.8125 14.25 14.4545 14.25 14.0127L14.25 11.7354Z",
    fill: "#3F3F3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 19.1582C14.2502 18.7166 14.6081 18.3584 15.0498 18.3584C15.4915 18.3584 15.8494 18.7166 15.8496 19.1582L15.8496 23.4854C15.8496 23.9272 15.4916 24.2852 15.0498 24.2852C14.608 24.2852 14.25 23.9272 14.25 23.4854L14.25 19.1582Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFridge);
export default __webpack_public_path__ + "static/media/fridge.b33208617856cd8925a63ecf3eda748a.svg";
export { ForwardRef as ReactComponent };